import React, { FC } from 'react';
import { isNullish } from '../../utils';
import styled from 'styled-components';
import { IconButton } from '../IconButton';

interface CountProps {
  pageCount?: number;
  offset?: number;
  totalCount?: number | null;
}

function numberFy(props: object, propName: string): number {
  const value = props[propName];
  if (value !== undefined) {
    const num = Number.parseInt(value);
    if (!isNaN(num)) return num;
  } //otherwise assume undefined
}
interface PaginationProps extends CountProps {
  testId?: string;
  handlePagination?: (value) => void;
  isNextDisabled?: boolean;
  isPreviousDisabled?: boolean;
}

function pageRangeText(props: object): string {
  const totalCount = numberFy(props, 'totalCount');
  if (isNullish(totalCount)) {
    return '- of -';
  }
  const offset = numberFy(props, 'offset');
  const pageCount = numberFy(props, 'pageCount');
  const offset1 = offset + 1;
  const tillNum = Math.min(offset + pageCount, totalCount);
  const fromNum = offset1 > tillNum ? tillNum : offset1;
  return `${fromNum} - ${tillNum} of ${totalCount}`;
}

export const Pagination: FC<PaginationProps> = ({
  isNextDisabled,
  isPreviousDisabled,
  handlePagination,
  testId,
  ...counts
}) => (
  <Wrapper data-test-id={testId}>
    <Content>{pageRangeText(counts)}</Content>
    <ButtonWrapper>
      <IconButton
        onClick={() => handlePagination('previous')}
        name="chevronBack"
        size="small3"
        isDisabled={isPreviousDisabled}
      />
      <IconRight
        onClick={() => handlePagination('next')}
        name="chevronBack"
        size="small3"
        isDisabled={isNextDisabled}
      />
    </ButtonWrapper>
  </Wrapper>
);

Pagination.displayName = 'Pagination';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div`
  font-size: 0.9em;
`;

const ButtonWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const IconRight = styled(IconButton)`
  &&& {
    transform: rotate(180deg);

    &:active {
      transform: scale(0.9) rotate(180deg);
    }

    &:disabled {
      transform: rotate(180deg);
    }
  }
`;
